<template>
    <component
      v-model="showModal"
      :is="isModal ? 'BaseModal' : 'Fragment'"
      :size="isModal ? 'xl' : undefined"
      modal-class="cashcall-create-modal"
      @hide="onModalHide"
    >
      <slot />
    </component>
  </template>

  <script>
  import Vue from 'vue'
  import { defineComponent, inject, nextTick } from '@vue/composition-api'
  import { Fragment } from 'vue-fragment'

  import { BaseModal } from '@components/base'
  import { computed } from '@vue/composition-api'

  import { CashCallFormInjectionKey } from './CashCallForm.constants'

  export default defineComponent({
    name: 'CashCallCreateModalWrapper',
    components: {
      Fragment,

      BaseModal
    },
    setup() {
      const { isModal, showModal, handleHideModal, saveDraftAndClose, hasChanges } = inject(
        CashCallFormInjectionKey
      )

       const onModalHide =  (evt) => {
        if (!isModal) return

        const trigger = evt.trigger

        if (hasChanges.value && trigger && trigger != 'ok') {
          evt.preventDefault()

          Vue.prototype.$swal({
            title: 'Confirmation',
            text: 'You have unsaved changes. Closing this window will save your Cash Call as a draft.',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Agree & Close',
            cancelButtonText: 'Cancel',
            preConfirm: async (isConfirmed) => {
              if (!isConfirmed) return

              // Actually persist the draft before closing (the dialog promises
              // it). Falls back to a plain close if the save bridge is absent.
              if (typeof saveDraftAndClose === 'function') {
                await saveDraftAndClose()
              } else {
                handleHideModal()
              }
            }
          })
        }
      }

      return {
        isModal,
        showModal,
        onModalHide,
      }
    }
  })
  </script>
  <style>
    .cashcall-create-modal .modal-footer {
      display: none !important;
    }
    /* No vertical scrollbar: the body grows to fit its content. But CLIP
       horizontal overflow so a wide step (the co-lead UMR table in edit mode)
       stays INSIDE the dialog instead of pushing the whole modal off the right
       of the screen. The table's own wrapper (.co-lead-umrs__table-wrap) has
       overflow-x:auto, so it scrolls internally to reach the far-right columns. */
    .cashcall-create-modal .modal-body {
      max-height: none !important;
      overflow-y: visible !important;
      overflow-x: hidden !important;
      /* Trim the large empty gap above the "Cash Call Request Form" title so the
         content sits near the top of the modal. */
      padding-top: 12px !important;
    }
    /* Belt-and-braces: never let the content block exceed the dialog width. */
    .cashcall-create-modal .modal-content {
      max-width: 100% !important;
      overflow-x: hidden !important;
    }
    /* Remove the default top margin on the title so it hugs the modal top. */
    .cashcall-create-modal .modal-title {
      margin-top: 0 !important;
    }
    /* The empty band above the title is the modal header (holds the X close).
       Shrink its padding so the body content starts near the top. The X stays
       clickable, just with tighter spacing. */
    .cashcall-create-modal .modal-header {
      padding: 6px 12px !important;
      border-bottom: none !important;
    }
  </style>
